import React from 'react';
import { useIntl } from 'react-intl';
import { defineMessages } from 'react-intl.macro';
import { useFragment } from 'react-relay/hooks';

import { graphql } from 'babel-plugin-relay/macro';

import { Typography, TypographyProps } from 'components/v2';

import { EnumMessageRef, TypographyMessageRef_Message$key } from './__generated__/TypographyMessageRef_Message.graphql';

export const messages = defineMessages({
  reminder: {
    id: 'deprecated.fragments.TypographyMessageRef.reminder',
    defaultMessage: 'Reminder',
  },
  waitlist: {
    id: 'deprecated.fragments.TypographyMessageRef.waitlist',
    defaultMessage: 'Waitlist',
  },
  offer: {
    id: 'deprecated.fragments.TypographyMessageRef.offer',
    defaultMessage: 'Offer',
  },
  feedback: {
    id: 'deprecated.fragments.TypographyMessageRef.feedback',
    defaultMessage: 'Feedback',
  },
  appointment: {
    id: 'deprecated.fragments.TypographyMessageRef.appointment',
    defaultMessage: 'Appointment',
  },
  referral: {
    id: 'deprecated.fragments.TypographyMessageRef.referral',
    defaultMessage: 'Referral',
  },
  broadcast: {
    id: 'deprecated.fragments.TypographyMessageRef.broadcast',
    defaultMessage: 'Broadcast',
  },
  patient: {
    id: 'deprecated.fragments.TypographyMessageRef.patient',
    defaultMessage: 'Patient',
  },
  telehealth: {
    id: 'deprecated.fragments.TypographyMessageRef.telehealth',
    defaultMessage: 'Telehealth',
  },
  waitingRoom: {
    id: 'deprecated.fragments.TypographyMessageRef.waitingRoom',
    defaultMessage: 'Waiting Room',
  },
  followup: {
    id: 'deprecated.fragments.TypographyMessageRef.followup',
    defaultMessage: 'Follow-up',
  },
  outboundReferral: {
    id: 'deprecated.fragments.TypographyMessageRef.outboundReferral',
    defaultMessage: 'Outbound Referral',
  },
  form: {
    id: 'deprecated.fragments.TypographyMessageRef.form',
    defaultMessage: 'Form',
  },
  reschedule: {
    id: 'deprecated.fragments.TypographyMessageRef.reschedule',
    defaultMessage: 'Reschedule',
  },
  chat: {
    id: 'deprecated.fragments.TypographyMessageRef.chat',
    defaultMessage: 'Chat',
  },
  pinVerification: {
    id: 'deprecated.fragments.TypographyMessageRef.pinVerification',
    defaultMessage: 'Pin Verification',
  },
  stop: {
    id: 'deprecated.fragments.TypographyMessageRef.stop',
    defaultMessage: 'Do not Contact',
  },
});

export const messageRefMapping: Record<EnumMessageRef, keyof typeof messages | '???'> = {
  reminder: 'appointment',
  referralReminder: 'referral',
  feedbackReminder: 'feedback',
  followup: 'followup',
  outboundReferralReminder: 'outboundReferral',
  formReminder: 'form',
  reschedule: 'reschedule',
  waitlist: 'waitlist',
  appointmentOffer: 'offer',
  chatNotification: 'chat',
  pinVerification: 'pinVerification',
  chat: 'chat',
  chatAudit: '???',
  chatAuditTz: '???',
  feedback: 'feedback',
  waitlistOffer: 'waitlist',
  referralFollowup: 'referral',
  outboundReferralOutreach: 'outboundReferral',
  referralRedirect: 'referral',
  broadcast: 'broadcast',
  generic: '???',
  stop: 'stop',
  botFollowup: 'followup',
  telehealth: 'telehealth',
  waitingRoomPatient: 'waitingRoom',
  '%future added value': '???',
};

export interface TypographyMessageRefProps extends Omit<TypographyProps, 'classes'> {
  fragmentRef: TypographyMessageRef_Message$key;
}

const TypographyMessageRef: React.FC<TypographyMessageRefProps> = ({ fragmentRef, ...rest }) => {
  const message = useFragment<TypographyMessageRef_Message$key>(
    graphql`
      fragment TypographyMessageRef_Message on Message {
        ref
      }
    `,
    fragmentRef,
  );

  const { formatMessage } = useIntl();

  if (!message.ref) {
    return null;
  }
  const ref = messageRefMapping[message.ref];
  if (!ref || ref === '???') {
    return null;
  }
  return <Typography {...rest}>{formatMessage(messages[ref])}</Typography>;
};

export default TypographyMessageRef;
